import angular from 'angular';

class cooperativeDetailCtrl {
    /* @ngInject */
    constructor(
        $state,
        CooperativeSvc,
        logger,
        EMAIL_REGEXP,
        AuthSvc,
        $uibModal
    ) {
        this.$state = $state;
        this.CooperativeSvc = CooperativeSvc;
        this.logger = logger;
        this.EMAIL_REGEXP = EMAIL_REGEXP;
        this.AuthSvc = AuthSvc;
        this.$uibModal = $uibModal;
    }

    $onInit() {
        this.includes = {
            errorMessages: require('../../layouts/error-messages.html'),
        };
        this.isAuthorizedToEdit = this.AuthSvc.isAuthorized('CONFIGURATOR');
        if (this.mode === 'create') {
            this.cooperative = {
                name: '',
                code: '',
                email: '',
                status: '',
                communityDto: {
                    eid: ''
                }
            }
        }

        this.isReadyForDeletion = false;
        if (this.mode === 'edit') {
            this.CooperativeSvc.isCooperativeDeletable(this.cooperative.id).then(
                data => {
                    this.isReadyForDeletion = data && this.isAuthorizedToEdit;
                }
            );

        }
    }



    save() {
        if (this.form.$valid) {
            this.cooperative.communityDto.eid = this.$state.params.eid;
            if (this.mode === 'edit') {
                this.CooperativeSvc.updateCooperative(this.cooperative).then(
                    () => {
                        this._onSaveSuccess('success.update');
                    },
                    error => {
                        this._onSaveError(error);
                    }
                );
            } else {
                this.CooperativeSvc.saveCooperative(this.cooperative).then(
                    () => {
                        this._onSaveSuccess('success.create');
                    },
                    error => {
                        this._onSaveError(error);
                    }
                );
            }
        }
    }

    _onSaveSuccess(message /*:string*/) {
        this.logger.success(message, null, null, { entityName: 'Le groupement' });
        this.$state.go('community.details.groupement-list');
    }

    _onSaveError(error) {
        if (error.status === 400 && error.data) {
            if (error.data.code === 'DUPLICATE_COMMUNITY_COOPERATIVE_CODE') {
                this.logger.error('error.duplicate_code_community_cooperative')
            }
        }
    }



    goBackToList() {
        this.$state.go('community.details.groupement-list');
    }

    /*
   * Suppression du groupement si il n'est paramétré dans aucun établissement
   */
    deleteCoperative() {
        this.$uibModal
            .open({
                component: 'modalDeleteCooperative',
                size: 'md',
                resolve: {
                    cooperative: () => {
                        return this.cooperative;
                    },
                },
            })
            .result.then(
                () => {
                    this.goBackToList();
                },
                () => { }
            );
    }

}

angular.module('app.community').component('cooperativeDetail', {
    templateUrl: require('./cooperative-detail.html'),
    controller: cooperativeDetailCtrl,
    bindings: {
        cooperative: '<',
        mode: '<',
    },
});
